import React, { useContext } from 'react';
import { ThemeProvider } from 'emotion-theming';
import { Theme, ThemeContext } from '../../utilities/theme';
import { ColorCodes, colorsForTheme } from '../../foundations/color';
import Icon from '../../foundations/Icons';
import {
  IconWrapper,
  ImageWrapper,
  NavAnchor,
  NavLink,
  OptionInnerNameWrapper,
  OptionNameWrapper,
  OptionRow,
  OptionRowContentLeft,
  SettingsAnchor,
  SettingsIconWrapper,
  SettingsLink,
} from './Switcher.styles';

type StateProps = {
  external?: boolean;
  option: {
    id: string;
    name: string;
    suppliers?: string[];
    logo?: string;
  };
  active: boolean;
  url: string;
};

const getTheme = (theme: Theme): themeStyles => {
  const colors = colorsForTheme(theme);
  const colorThemes = {
    textColor: colors.SPACE,
    iconColor: colors.STORM,
    iconBorderColor: colors.ASH,
    activeColor: colors.PEACH,
    activeIconColor: colors.BUTTON_ORANGE,
    activeRowColor: colors.LIGHT_PEACH,
  };
  return colorThemes;
};

type themeStyles = {
  textColor: ColorCodes;
  iconColor: ColorCodes;
  iconBorderColor: ColorCodes;
  activeColor: ColorCodes;
  activeIconColor: ColorCodes;
  activeRowColor: ColorCodes;
};

export const SwitcherOption = (props: StateProps) => {
  const themeStyle = getTheme(useContext(ThemeContext));
  const { option, external, active = false, url } = props;

  const optionContent = (
    <OptionRowContentLeft>
      {option.logo ? (
        <ImageWrapper src={option.logo} />
      ) : (
        <IconWrapper isActive={active}>
          <Icon name="mShopFront" inheritFill />
        </IconWrapper>
      )}
      <OptionNameWrapper>
        <OptionInnerNameWrapper>{option.name}</OptionInnerNameWrapper>
      </OptionNameWrapper>
    </OptionRowContentLeft>
  );

  return (
    <ThemeProvider theme={themeStyle}>
      <OptionRow key={option.id} isActive={active}>
        {external ? (
          <NavAnchor key={option.id} href={url}>
            {optionContent}
          </NavAnchor>
        ) : (
          <NavLink key={option.id} to={url}>
            {optionContent}
          </NavLink>
        )}
        {option.suppliers && (
          <>
            {external ? (
              <SettingsAnchor
                href={`/dashboard/settings/venues/${option.id}/general`}
              >
                <SettingsIconWrapper>
                  <Icon name="lSettings" inheritFill />
                </SettingsIconWrapper>
              </SettingsAnchor>
            ) : (
              <SettingsLink
                to={`/dashboard/settings/venues/${option.id}/general`}
              >
                <SettingsIconWrapper>
                  <Icon name="lSettings" inheritFill />
                </SettingsIconWrapper>
              </SettingsLink>
            )}
          </>
        )}
      </OptionRow>
    </ThemeProvider>
  );
};
export default SwitcherOption;
